import React, { useState, useEffect } from "react";
import axios from "axios";
import YouTube from "react-youtube";
import { FaAward, FaCode, FaUsers } from "react-icons/fa";
import { MdSchool } from "react-icons/md";

import baseUrl from "../components/baseurl";

const About = () => {
  const [aboutData, setAboutData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const stats = [
    { icon: <FaCode />, value: "4", label: "Years of Experience" },
    { icon: <FaAward />, value: "15+", label: "Completed Projects" },
    { icon: <FaUsers />, value: "10+", label: "Satisfied Clients" },
    { icon: <MdSchool />, value: "4+", label: "Certifications" },
  ];

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/aboutmeget/648706cfb93cba72f3b1bfe2`
        );
        setAboutData(response.data);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching about data:", error);
        setIsLoading(false);
      }
    };

    fetchAboutData();
  }, []);

  const extractYouTubeId = (url) => {
    if (!url) return null;

    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|shorts\/|\?v=)([^#&?]*).*/;
    const match = url.match(regExp);

    return match && match[2].length === 11 ? match[2] : null;
  };

  const LoadingSpinner = () => (
    <div className="flex items-center justify-center p-8">
      <div className="relative">
        <div className="h-16 w-16 rounded-full border-t-4 border-b-4 border-blue-500 animate-spin"></div>
        <div className="absolute top-0 left-0 h-16 w-16 rounded-full border-t-4 border-b-4 border-blue-200 animate-spin animate-pulse"></div>
      </div>
    </div>
  );

  return (
    <div className="container mx-auto px-6 py-16">
      <div className="text-center mb-16">
        <h2 className="text-4xl font-bold text-indigo-900 mb-4">About Me</h2>
        <div className="h-1 w-24 bg-indigo-500 mx-auto"></div>
      </div>

      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="relative mx-auto max-w-md">
              <div className="absolute -inset-1 bg-gradient-to-r from-indigo-500 to-blue-500 rounded-2xl blur opacity-30"></div>
              <div className="relative overflow-hidden rounded-2xl">
                <img
                  src="/assets/insights.jpg"
                  alt="Ayobami Isaac"
                  className="w-full h-auto rounded-2xl shadow-xl transform transition duration-500 hover:scale-105"
                />
              </div>
            </div>

            <div className="mt-10">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">
                About Video
              </h3>
              <div className="rounded-2xl overflow-hidden shadow-xl">
                {isLoading ? (
                  <LoadingSpinner />
                ) : (
                  <YouTube
                    videoId={
                      extractYouTubeId(aboutData?.vidUrl) || "Jz_ACml012M"
                    }
                    opts={{
                      height: "360",
                      width: "100%",
                      playerVars: {
                        autoplay: 0,
                      },
                    }}
                    className="w-full"
                    onError={(e) => console.error("YouTube Error:", e)}
                  />
                )}
              </div>
            </div>
          </div>

          <div className="space-y-8">
            <div>
              <h3 className="text-3xl font-bold text-gray-800 mb-6">
                Who I Am
              </h3>
              {isLoading ? (
                <LoadingSpinner />
              ) : (
                <div className="prose prose-lg max-w-none text-gray-600 leading-relaxed">
                  {aboutData?.about ? (
                    <p>{aboutData.about}</p>
                  ) : (
                    <p>
                      I'm a passionate full-stack developer with a strong focus
                      on creating efficient, scalable, and user-friendly web
                      applications. My expertise spans across both frontend and
                      backend technologies, allowing me to build complete
                      solutions that deliver exceptional user experiences.
                    </p>
                  )}
                </div>
              )}
            </div>

            <div className="mt-12">
              <h3 className="text-2xl font-bold text-gray-800 mb-6">
                Experience Highlights
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                {stats.map((stat, index) => (
                  <div
                    key={index}
                    className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300"
                  >
                    <div className="text-indigo-600 mb-2 text-3xl">
                      {stat.icon}
                    </div>
                    <h4 className="text-3xl font-bold text-gray-900">
                      {stat.value}
                    </h4>
                    <p className="text-gray-500 mt-1">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-12 flex flex-wrap gap-4">
              <a
                href="/assets/resume.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-lg transition-colors duration-300 inline-flex items-center"
              >
                Download Resume
              </a>
              <button
                onClick={() => {
                  const contactSection = document.querySelector("#contact");
                  if (contactSection) {
                    contactSection.scrollIntoView({ behavior: "smooth" });
                  }
                }}
                className="px-6 py-3 bg-white border border-indigo-600 text-indigo-600 hover:bg-indigo-50 font-medium rounded-lg transition-colors duration-300 inline-flex items-center"
              >
                Get In Touch
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
